import * as React from "react"

export const CompanySelectionPage = () => (
    <p>CompanySelectionPage</p>
)
